import React, { useState, useContext } from 'react';

import NavTaxiSelectContext from "./NavTaxiSelectContext";

// NavTaxiSelectContext

function NativeSelectDropdown() {
  const [selectedValue, setSelectedValue] = useState('all');
  // const { theme, toggleTheme } = useContext(ThemeContext);
  const { navTaxiSelectFunc } = useContext(NavTaxiSelectContext);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    // NavTaxiSelectContext._currentValue = event.target.value;
    navTaxiSelectFunc(event.target.value);
    // You can add other logic here that should trigger when a selection is made
    // console.log('Selection changed to:', event.target.value);
  };

  return (
    <div>
      {/* <NavTaxiSelectContext.Provider value={selectedValue}> */}
        {/* <label htmlFor="my-dropdown">Choose an option: </label> */}
        <select
          className='dropdown-taxi'
          id="taxi-dropdown"
          value={selectedValue}
          onChange={handleChange}
          // onChange={(e) => navTaxiSelectFunc(e.target.value)}
        >
          <option value="all">ALL TAXIS</option>
          <option value="group">GROUP</option>
          <option value="jennie">JENNIE</option>
          <option value="jisoo">JISOO</option>
          <option value="lisa">LISA</option>
          <option value="rose">ROSÉ</option>
        </select>
        {/* {selectedValue && <p>You selected: {selectedValue}</p>} */}
      {/* </NavTaxiSelectContext.Provider> */}
    </div>
  );
}
export default NativeSelectDropdown;